import type { ReactNode } from 'react'
import React from 'react'

import { colors, Row, Theme, Expander, ExpanderContent, ExpanderHeader, WhiteTheme, H2, Separator } from '@fs/zion-ui'
import { css } from '@emotion/core'

const bannerWrapperCss = css`
  padding: 8px 0;
`

type BannerProps = {
  Icon: ({ color, size }) => JSX.Element
  title: string
  message: ReactNode
  action?: ReactNode
  metaText?: ReactNode
  initiallyOpen?: boolean
}
export default function Banner({ Icon, title, message, action, metaText, initiallyOpen }: BannerProps): JSX.Element {
  return (
    <Theme theme="night" css={bannerWrapperCss} transparent>
      <Expander initiallyOpen={initiallyOpen}>
        <ExpanderHeader data-testid="banner-expander-button">
          <Row alignY="middle" guttersY="none">
            <Icon color={colors.gray100} size="sm" />
            <H2 size="H5" data-testid="person-header-banner">
              {title}
            </H2>
          </Row>
        </ExpanderHeader>
        <ExpanderContent>
          <Separator size="nano" />
          {message}

          {(metaText ?? action) && (
            <WhiteTheme>
              <Row wrap gutters="nano">
                <div growX noShrinkX>
                  {metaText}
                </div>
                <span noShrinkX>{action}</span>
              </Row>
            </WhiteTheme>
          )}
        </ExpanderContent>
      </Expander>
    </Theme>
  )
}
